import type { Notification } from '@nexo/types';
import { t } from '../../lib/i18n';

/** Human text and target route for a notification. */
export function notificationText(notification: Notification): { title: string; href: string } {
  const { data } = notification;
  switch (data.type) {
    case 'task_assigned':
      return {
        title: t('Te han asignado «{{task}}»', { task: data.taskTitle }),
        href: `/app/t/${data.teamId}/tasks?task=${data.taskId}`,
      };
    case 'team_invite':
      return {
        title: t('Invitación para unirte a {{team}}', { team: data.teamName }),
        href: '/app/home',
      };
    case 'meeting_invite':
      return {
        title: t('Te han invitado a «{{title}}»', { title: data.title }),
        href: `/app/t/${data.teamId}/meetings?meeting=${data.meetingId}`,
      };
    case 'meeting_starting':
      return {
        title: t('«{{title}}» empieza en unos minutos', { title: data.title }),
        href: `/app/t/${data.teamId}/meetings?meeting=${data.meetingId}`,
      };
    case 'meeting_cancelled':
      return {
        title: t('Se ha cancelado «{{title}}»', { title: data.title }),
        href: `/app/t/${data.teamId}/meetings`,
      };
    case 'reply':
      return {
        title: t('Han respondido a tu mensaje en {{channel}}', { channel: data.channelName }),
        href: `/app/t/${data.teamId}/c/${data.channelId}`,
      };
    case 'thread_reply':
      return {
        title: t('Nueva respuesta en un hilo de {{channel}}', { channel: data.channelName }),
        href: `/app/t/${data.teamId}/c/${data.channelId}?thread=${data.messageId}`,
      };
    case 'reminder':
      return {
        title: data.text
          ? t('Recordatorio: {{text}}', { text: data.text })
          : t('Tienes un recordatorio'),
        href: data.channelId
          ? `/app/t/${data.teamId}/c/${data.channelId}${data.messageId ? `?m=${data.messageId}` : ''}`
          : `/app/t/${data.teamId}`,
      };
    case 'scheduled_failed':
      return {
        title: t('No se pudo enviar tu mensaje programado: «{{text}}»', { text: data.preview }),
        href: `/app/t/${data.teamId}/c/${data.channelId}`,
      };
    case 'summary_failed':
      return {
        title: t('No se pudo hacer el resumen de la llamada'),
        href: `/app/t/${data.teamId}/c/${data.channelId}`,
      };
    case 'mention':
      return {
        title: data.everyone
          ? t('Aviso para todo {{channel}}', { channel: data.channelName })
          : data.roleName
            ? t('Aviso para @{{role}} en {{channel}}', {
                role: data.roleName,
                channel: data.channelName,
              })
            : t('Te han mencionado en {{channel}}', { channel: data.channelName }),
        href: `/app/t/${data.teamId}/c/${data.channelId}`,
      };
  }
}
